import PlotDefinition from "./model/PlotDefinition";
import PointDefinition from "./model/PointDefinition";
import {Form} from "../../../../model/form/form";
import m, {Vnode} from "mithril";
import AvailablePoints from "./components/AvailablePoints";
import DragDropChartPlot from "./components/DragDropChartPlot";

export default class DragDropChartBox {

    private readonly imagesComponent: AvailablePoints;
    private readonly plotComponent: DragDropChartPlot;

    public draggedPoint: PointDefinition|null = null;
    private draggedPoint2: PointDefinition|null = null; // touchend hack

    // Dragged point position relative to DragDropChartBox
    private dpPosition: {x: number, y: number}|null = null;
    // Dragged point position relative to page
    private dpPagePosition: {x: number, y: number}|null = null;
    // Dragged point position relative to client window
    private dpClientPosition: {x: number, y: number}|null = null;

    private readonly self;

    constructor(
        public readonly plotDefinition: PlotDefinition,
        public readonly pointDefinitions: PointDefinition[],
        public readonly form: Form
    ) {
        this.self = this;
        this.imagesComponent = new AvailablePoints(this);
        this.plotComponent = new DragDropChartPlot(this);
    }

    private updateDraggedPointPosition(e: TouchEvent|PointerEvent): void {
        const {clientX, clientY, pageX, pageY} = <PointerEvent>((window.TouchEvent && e instanceof TouchEvent) ? e.touches[0] : e);
        if (this.draggedPoint) {
            const bb = (<HTMLElement>e.currentTarget).getBoundingClientRect();

            this.self.dpPosition = {
                x: clientX - bb.left,
                y: clientY - bb.top,
            }

            this.self.draggedPoint2 = this.draggedPoint;
            this.self.dpPagePosition = {
                x: pageX,
                y: pageY
            }
            this.self.dpClientPosition = {
                x: clientX,
                y: clientY
            }

        }
    }

    private cancelPoint(): void {
        this.self.draggedPoint = null;
        this.self.dpPosition = null;
    }

    private viewPoint(): Vnode|null {
        const coordinates = this.plotComponent.cursorPoint;
        return (this.draggedPoint && this.dpPosition) ? m('.point-dragged', {
            draggable: false,
            style: `left: ${this.dpPosition.x}px; top: ${this.dpPosition.y}px`,
        }, [
            m('.point-inner', {}, [
                coordinates ? m('.coordinates', {},
                    m('span', {}, `[ ${coordinates.x} , ${coordinates.y} ]`),
                ) : null,
                m('img', {
                    src: this.draggedPoint.imageUrl,
                    draggable: false,
                }),
            ])
        ]) : null;
    }

    public view(): Vnode {
        const self = this.self
        return m('.DragDropChartBox', {
            onpointerdown: (e: PointerEvent) => this.updateDraggedPointPosition(e),
            onpointermove: (e: PointerEvent) => this.updateDraggedPointPosition(e),
            ontouchmove: (e: TouchEvent) => this.updateDraggedPointPosition(e),
            onpointerleave: () => this.cancelPoint(),
            onpointerup: () => this.cancelPoint(),
            onpointercancel: () => this.cancelPoint(),
            ontouchend: () => {
                // Hack touchend event to trick app to place point inside different element
                // 1. search target element
                // 2. in case Available images element => drop it there
                //    in case of Plot element => pass fake PointerEvent-like object
                // 3. reset dragged point state
                if (self.dpPagePosition && self.dpClientPosition) {
                    const el = document.elementFromPoint(self.dpClientPosition.x, self.dpClientPosition.y);
                    if (el) {
                        const $target=  $(el).closest('.AvailableImages, .DragDropChartPlot');
                        if ($target.is('.AvailableImages')) {
                            self.draggedPoint = self.draggedPoint2;
                            self.imagesComponent.drop();
                        } else if ($target.is('.DragDropChartPlot')) {
                            self.draggedPoint = self.draggedPoint2;
                            // @ts-ignore
                            this.self.plotComponent.drop({
                                clientX: self.dpClientPosition.x,
                                clientY: self.dpClientPosition.y,
                                currentTarget: $target[0],
                            });
                        }
                    }
                    self.draggedPoint = null;
                    self.draggedPoint2 = null;
                    self.dpPagePosition = null;
                    self.dpClientPosition = null;
                    m.redraw();
                }
            },
        }, [
            m(this.imagesComponent),
            m(this.plotComponent),
            this.viewPoint(),
        ])
    }
}